export default "__VITE_ASSET__Dul6L4cX__"